import { WebhooksPage } from "@/features/developer/webhooks";

export default function DeveloperWebhooksPage() {
  return <WebhooksPage />;
}
